import type { PageHeaderBreadcrumb } from '@verantos-dev/shared-components';

import { useProjectRootBreadcrumbs } from './useProjectRootBreadcrumbs';

export interface UseVariableDraftBreadcrumbsResult {
  breadcrumbs: PageHeaderBreadcrumb[];
}

/**
 * Per-page breadcrumbs for the in-flight analytical-variable draft surface
 * (OR-6123 F8). `Projects / <project> / <draft title>` — the trailing crumb is
 * the draft's working title (the agent-supplied scope title, else the slug,
 * else a generic label). Split out of the old monolithic
 * `useProjectBreadcrumbs`.
 *
 * TODO: cleanup with research_assistant_gen_3 ff
 */
export const useVariableDraftBreadcrumbs = ({
  draftTitle,
}: {
  draftTitle: string;
}): UseVariableDraftBreadcrumbsResult => {
  const { rootCrumbs } = useProjectRootBreadcrumbs();

  return {
    breadcrumbs: [...rootCrumbs, { label: draftTitle }],
  };
};
